/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC skew is (G − C) ÷ (G + C) measured over a window of sequence. It captures the strand asymmetry between guanine and cytosine content.`)
};

const es_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El sesgo GC es (G − C) ÷ (G + C) medido en una ventana de secuencia. Capta la asimetría de hebra entre el contenido de guanina y citosina.`)
};

const de_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-Skew ist (G − C) ÷ (G + C), gemessen über ein Sequenzfenster. Er erfasst die Strangasymmetrie zwischen Guanin- und Cytosingehalt.`)
};

const nl_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC-skew is (G − C) ÷ (G + C) gemeten over een venster van de sequentie. Het geeft de strengasymmetrie tussen guanine- en cytosinegehalte weer.`)
};

const fr_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le biais GC est (G − C) ÷ (G + C) mesuré sur une fenêtre de séquence. Il capture l'asymétrie de brin entre le contenu en guanine et en cytosine.`)
};

const it_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo skew GC è (G − C) ÷ (G + C) misurato su una finestra di sequenza. Cattura l'asimmetria di filamento tra il contenuto di guanina e citosina.`)
};

const pt_br2_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC skew é (G − C) ÷ (G + C) medido sobre uma janela de sequência. Ele captura a assimetria entre fitas quanto ao conteúdo de guanina e citosina.`)
};

const pt_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A assimetria GC é (G − C) ÷ (G + C) medida numa janela de sequência. Capta a assimetria entre cadeias no conteúdo de guanina e citosina.`)
};

const ja_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`配列の窓ごとに測定される (G − C) ÷ (G + C) です。グアニンとシトシン含量の鎖間の非対称性を捉えます。`)
};

const zh_gcskew_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC 偏斜是在一个序列窗口内测得的 (G − C) ÷ (G + C)。它反映了鸟嘌呤与胞嘧啶含量之间的链不对称性。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gcskew_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gcskew_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gcskew_faq_a1", locale)
	if (locale === "en") return en_gcskew_faq_a1(inputs)
	if (locale === "es") return es_gcskew_faq_a1(inputs)
	if (locale === "de") return de_gcskew_faq_a1(inputs)
	if (locale === "nl") return nl_gcskew_faq_a1(inputs)
	if (locale === "fr") return fr_gcskew_faq_a1(inputs)
	if (locale === "it") return it_gcskew_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_gcskew_faq_a1(inputs)
	if (locale === "pt") return pt_gcskew_faq_a1(inputs)
	if (locale === "ja") return ja_gcskew_faq_a1(inputs)
	return zh_gcskew_faq_a1(inputs)
};